import { z } from "zod";

/**
 * PRTL-1392: Zod 4 probes whether eval is allowed (`new Function("")`) the
 * first time it builds an object schema, to decide on its JIT fast path. Under
 * the strict CSP (no 'unsafe-eval') that probe is refused and logged as a
 * violation on every page load. `jitless` skips the probe and the JIT; the web
 * app only parses small payloads, so the fast path is not missed.
 *
 * Must run before any schema is built. index.tsx imports this first, and the
 * build puts this file in Zod's own chunk (`vendor-zod`, vite.config.ts), so it
 * runs as soon as Zod is loaded, whichever chunk loads Zod first. Importing it
 * first is not enough on its own: modules in a shared chunk run together.
 */
z.config({ jitless: true });
